import { useEffect, useState } from "react";
import { Box, IconButton, Typography, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Checkbox, Autocomplete, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Controller, useForm } from "react-hook-form";
import { CiExport, CiFilter } from "react-icons/ci";
import { useFetchGetallUserListQuery, useFetchMonthlyLogsQuery } from "../../../../slice/logdetailSlice";
import Loader, { BtnLoader } from "../../../../components/common/Loader";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { createEntity, filterEntities,} from "../../../../apis/apiService";
import { toast } from "react-toastify";
import { extractTextFromHTML } from "../../../../utils/textUtils";
import { useTheme } from "../../../../ThemeContext";


const ActionLogs = () => {
  const { isDarkMode } = useTheme();
  const [filterOpen, setFilterOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [filterLoading, setFilterLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const { data, refetch, isLoading } = useFetchMonthlyLogsQuery();
  // console.log("data:", data);
  const [filteredData, setFilteredData] = useState([]);
  const [exportDate, setExportDate] = useState({
    start_date: dayjs().startOf("month").format("YYYY-MM-DD"),
    end_date: dayjs().endOf("month").format("YYYY-MM-DD"),
  });
  const [userId, setUserId] = useState(null);
  const { data: UserNameOptions } = useFetchGetallUserListQuery();
  const userNameList = UserNameOptions?.map((user) => ({
    id: user.user_id,
    title: user.name,
  }));

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      Users: [],

      startDate: null,
      endDate: null,
    },
  });
  const exportToExcel = async () => {
    const requestedData = {
      from_date: exportDate.start_date,
      to_date: exportDate.end_date,
    };
    if (userId) {
      requestedData.user_id = userId;
    }
    try {
      const response = await createEntity("exportactionLogs", requestedData);
      if (response?.doc_url) {
        toast.success(response.message);
        // Trigger the download
        const link = document.createElement("a");
        link.href = response.doc_url;
        link.setAttribute("download", "MonthlyLogs.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } 
    catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (data) {
      setFilteredData(data); // Set default when data arrives
    }
  }, [data]);

  const onSubmit = async (formData) => {
    try {
      setFilterLoading(true);

      // const startOfMonth = formData.StartDate
      //   ? dayjs(formData.StartDate).startOf("month").format("YYYY-MM-DD")
      //   : null;

      // const endOfMonth = formData.StartDate
      //   ? dayjs(formData.StartDate).endOf("month").format("YYYY-MM-DD")
      //   : null;
      setExportDate({
        start_date: formData.startDate
          ? dayjs(formData.startDate).format("YYYY-MM-DD")
          : null,
        end_date: formData.endDate
          ? dayjs(formData.endDate).format("YYYY-MM-DD")
          : null,
      });
      setUserId(formData.Users);
      const requestedData = {
        user_id: formData.Users,
        from_date: formData.startDate
          ? dayjs(formData.startDate).format("YYYY-MM-DD")
          : null,
        to_date: formData.endDate
          ? dayjs(formData.endDate).format("YYYY-MM-DD")
          : null,
      };

      // console.log("requestedData:", requestedData);

      const response = await filterEntities("actionLogs", requestedData);

      if (response?.data) {
        setFilteredData(response.data); // Update filtered logs
        setFilterOpen(false); // Close filter popup
        toast.success(response.message);
        setShowFilter(true);
      }
    } 
    catch (error) {
      // console.error("Filter error:", error);
      toast.error(error.message);
    } 
    finally {
      setFilterLoading(false);
      
    }
  };
  const handleClearFilter = async () => {
    const freshData = await refetch();
    setFilteredData(freshData.data);
    setShowFilter(false);
    setExportDate({
      start_date: dayjs().startOf("month").format("YYYY-MM-DD"),
      end_date: dayjs().endOf("month").format("YYYY-MM-DD"),
    });
    setUserId(null);
    reset();
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className=" d-flex align-items-center justify-content-end my-3">
            {/* <Typography variant="h6">Monthly Logs</Typography> */}
            <Box>
              {showFilter && (
                <button
                  className=" addmore_btn mx-4"
                  onClick={handleClearFilter}
                >
                  Clear filter
                </button>
              )}

              <Tooltip title="Filter" arrow>
                <IconButton
                  sx={{
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    marginRight: "16px",
                    "&:hover": {
                      backgroundColor: "var(--icon-hover-bg)",
                    },
                  }}
                  onClick={() => setFilterOpen(true)}
                >
                  <CiFilter className="text-rgbr-blue pro-icon-s" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Export" arrow>
                <IconButton
                  sx={{
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    marginRight: "16px",
                    "&:hover": {
                      backgroundColor: "var(--icon-hover-bg)",
                    },
                  }}
                  onClick={exportToExcel}
                >
                  <CiExport className="text-rgbr-blue pro-icon-s" />
                </IconButton>
              </Tooltip>
            </Box>
          </div>

          {filteredData.length <= 0 ? (
            <p className=" text-center my-5">No data found</p>
          ) : (
            <div className=" p-2 tableScroll">
              {filteredData?.map((entry) => (
                <Box key={entry.date} mb={2}>
                  <Typography variant="subtitle2" gutterBottom>
                    {dayjs(entry.date).format("dddd - DD/MM/YYYY")}
                  </Typography>
                  {entry.activities.map((act, index) => (
                    <Box
                      key={index}
                      display="flex"
                      alignItems="center"
                      ml={2}
                      mb={1}
                    >
                      <Typography
                        variant="body2"
                        sx={{ textWrap: "nowrap" }}
                        color="textSecondary"
                        mr={3}
                      >
                        {act.time}
                      </Typography>
                      <Typography variant="body2">
                        {extractTextFromHTML(act.message)}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ))}

              {/* Filter Dialog */}
              <Dialog
                open={filterOpen}
                maxWidth="md"
                fullWidth
                sx={{
                  "& .MuiDialog-paper": {
                    minHeight: "60vh",
                    width: "90%",
                    maxWidth: "500px",
                    borderRadius: "12px",
                  },
                }}
                onClose={() => setFilterOpen(false)}
              >
                <DialogTitle>Filter Logs</DialogTitle>
                <DialogContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    mt: 1,
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="row">
                        <div className="col-md-12 mt-3">
                          <label htmlFor="Users" className="form-label">
                            Users
                          </label>

                          <Controller
                            name="Users"
                            control={control}
                            // rules={{required:"user field "}}
                            render={({ field: { onChange, value } }) => (
                              <Autocomplete
                                multiple
                                id="Users"
                                options={
                                  Array.isArray(userNameList)
                                    ? userNameList
                                    : []
                                }
                                disableCloseOnSelect
                                getOptionLabel={(option) => option.title}
                                value={
                                  (value || [])
                                    .map((id) =>
                                      userNameList?.find(
                                        (user) => user.id === id
                                      )
                                    )
                                    .filter(Boolean) || []
                                }
                                onChange={(event, newValue) => {
                                  const selectedTitles = newValue.map(
                                    (user) => user.id
                                  );
                                  onChange(selectedTitles);
                                }}
                                renderOption={(props, option, { selected }) => (
                                  <li
                                    {...props}
                                    className="d-flex align-items-center mb-2"
                                  >
                                    <Checkbox
                                      style={{ marginRight: 8 }}
                                      checked={selected}
                                    />
                                    <strong>{option.title}</strong>
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField {...params} placeholder="Users" />
                                )}
                                ListboxProps={{
                                  style: {
                                    display: "grid",
                                    gridTemplateColumns: "1fr",
                                    gap: "8px",
                                    paddingLeft: "0",
                                  },
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label htmlFor="startDate" className="form-label">
                            Start Date
                          </label>
                          <div className=" d-flex  flex-column w-100 ">
                            <Controller
                              name="startDate"
                              control={control}
                              render={({ field }) => (
                                <DatePicker
                                  {...field}
                                  format="DD/MM/YYYY"
                                  onChange={(date) => field.onChange(date)}
                                  renderInput={(params) => (
                                    <input
                                      className="form-control datepic_ip"
                                      {...params}
                                    />
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div>
                        
                        <div className="col-md-6">
                          <label htmlFor="endDate" className="form-label">
                            End Date
                          </label>
                          <div className=" d-flex  flex-column w-100 ">
                            <Controller
                              name="endDate"
                              control={control}
                              render={({ field }) => (
                                <DatePicker
                                  format="DD/MM/YYYY"
                                  {...field}
                                  onChange={(date) => field.onChange(date)}
                                  renderInput={(params) => (
                                    <input
                                      className="form-control datepic_ip"
                                      {...params}
                                    />
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>

                      <DialogActions>
                        <button
                          type="button"
                          className="cancel_btn"
                          onClick={() => {
                            setFilterOpen(false);
                            reset();
                          }}
                          disabled={filterLoading}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="add_btn"
                          disabled={filterLoading}
                        >
                          {filterLoading ? (
                            <>
                              <BtnLoader />
                            </>
                          ) : (
                            "Apply"
                          )}
                        </button>
                      </DialogActions>
                    </form>
                  </LocalizationProvider>
                </DialogContent>
              </Dialog>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ActionLogs;
